var React = require('react');

function ArrowRight16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=16x16, Hover=Off, Inverted=on"},React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M8.68.267a1 1 0 10-1.36 1.466L12.992 7H0v2h12.992L7.32 14.267a1 1 0 001.36 1.466l7-6.5.32-.297V7.064l-.32-.297-7-6.5z","fill":"currentColor"})));
}

ArrowRight16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight16x16;

ArrowRight16x16.default = ArrowRight16x16;
